import { post } from "mdui/api/HttpReq";
import { loadData  } from "../functions/wuiUtils.jsx";
import { getField } from "mdui/form/Util";
import { AlertType } from 'mdui/page/MsgBox';
import { useUtil } from "mdui/page/UtilProvider";

const fillBankCode = async ({
  formData,
  updateState
}) => {
  const val = formData.bank;
  updateState({ newFormData: { ...formData, acctToBnkCd: val } });
};

const fillEventCode = async ({
  formData,
  updateState
}) => {
  const val = formData.eventCode;
  updateState({ newFormData: { ...formData, eventCode: val } });
};


const submitWorkListItem = async ({
  param,
  config,
  props,
  formData,
  updateState,
  openModel,
  showSuccessModal = false,
  successMsg
}) => {
  console.log("submitWorkListItem param:", param);

  const val = await post("md-mod-cfg", "add-wui-data", param);
  console.log("submitWorkListItem response:", val);

  const pageCfg = config.pages[config.cPKey];

  const tbl = getField(
    pageCfg.config,
    props.field.callbackArgs
  );

  console.log("calling loadData...");

  const newTable = await loadData(
    "md-mod-cfg",
    "read",
    { module: pageCfg.module, action: "search" },
    {
      ...formData,
      initOpr: null,
      parentPK: config.initPK
    },
    tbl
  );
  if (showSuccessModal) {
  updateState({
    newFormData: {
      ...formData,
      table: newTable
    }, newMsg :successMsg ||"WorkListItem action has been done successfully"
  });
  }else{
    updateState({
      newFormData: {
        ...formData,
        table: newTable
      }
    });
  }
  console.log("state updated, staying on same page");

  // Optionally show success modal if flag is enabled and handler is provided
/*if (showSuccessModal && typeof openModel === "function") {
  openModel({
    msg: successMsg || "WorkListItem action has been done successfully",
    type: AlertType.S
  });
}*/
};


const wrkSuccess = async (args) => {
  console.log("wrkSuccess args:", args);

  const {
    props,
    formData,
    updateState,
    config,
    showDialog
  } = args;

  if (!showDialog) return;

  // Check for special channel
  if (props.row?.rqstChnl === "BPG3HCB") {
    showDialog({
      props: { field: props.field },
  
      labels: {
        title: "WorkListItem Confirmation",
        description: "4EV - Approve Routing Failure"
      },
  
      ok: {
        label: "Submit",
        color: "success",
        onClick: async (dialogData) => {
          const action = dialogData.modalData?.selection; // radio value
          const reason = dialogData.modalData?.comments || "";
  
          const pageCfg = config.pages[config.cPKey];
          const row = props.row;
  
          if (!row) return;
  
          const updatedRow = {
            ...row,
            wAction: action,
            comments: reason,
         //   bpgAction: action
          };

          console.log("Updated Row",updatedRow);
  
          const param = {
            module: pageCfg.module,
            action: "edit",
            initOpr: "edit",
            parentPK: row.entityId,
            modPK: row.entityId,
            ...updatedRow
          };
  
          await submitWorkListItem({
            param,
            props,
            formData,
            updateState,
            config
          });
          //api call
        }
      },
  
      cancel: {
        label: "No",
        color: "danger"
      },
  
      showRadioField: true
    });
  
    return;
  }
  
  
  // Default dialog logic for other channels
  showDialog({
    props: { field: props.field },

    labels: {
      title: "WorkListItem Confirmation",
      description: "Please enter comments to complete worklist item"
    },

    ok: {
      label: "Submit",
      color: "success",
      onClick: async (dialogData) => {
        const comments = dialogData.modalData?.comments || "";
        const pageCfg = config.pages[config.cPKey];
        const row = props.row;

        if (!row) {
          console.error("No row found for worklist submit");
          return;
        }

        const updatedRow = {
          ...row,
          wAction: "complete",
          comments,
        };

        const param = {
          module: pageCfg.module,
          action: "edit",
          initOpr: "edit",
          parentPK: row.entityId,
          modPK: row.entityId,
          ...updatedRow
        };

        await submitWorkListItem({
          param,
          props,
          formData,
          updateState,
          config
        });
      }
    },

    cancel: {
      label: "No",
      color: "danger"
    },

    showCommentsField: true
  });
};

const WkReclaim = async (args) => {
  const {
    props,
    formData,
    updateState,
    config,openModel
  } = args;
  const pageCfg = config.pages[config.cPKey];
  const row = props.row;
  if (!row) {
    console.error("No row found for worklist reclaim");
    return;
  }

  const updatedRow = {
    ...row,
  //  status: "ASSIGNED",
//    assigne: "dxpmaker",
wAction:"claim",
   // claimDatetime: getCurrentDateTime(),
  };

  const param = {
    module: pageCfg.module,
    action: "edit",
    initOpr: "edit",
    parentPK: row.entityId,
    modPK: row.entityId,
    ...updatedRow
  };

  await submitWorkListItem({
    param,
    props,
    formData,
    updateState,
    config,
    openModel,
    showSuccessModal: true,
    successMsg: "WorkListItem assigned action has been done successfully"
  });
  
};

const wkRelease = async (args) => {
  const {
    props,
    formData,
    updateState,openModel,
    config,
  } = args;
  
  const pageCfg = config.pages[config.cPKey];
  const row = props.row;

  if (!row) {
    console.error("No row found for worklist release");
    return;
  }

  const updatedRow = {
    ...row,
    wAction:"release",
    //status: "NEW",    
   // assigne: "",    
   // claimDatetime: "",
  };

  const param = {
    module: pageCfg.module,
    action: "edit",
    initOpr: "edit",
    parentPK: row.entityId,
    modPK: row.entityId,
    ...updatedRow
  };

  await submitWorkListItem({
    param,
    props,
    formData,
    updateState,
    config,
    openModel,
    showSuccessModal: true,
    successMsg: "WorkListItem new action has been done successfully"
  });
};


export {
  fillBankCode,
  fillEventCode,
  wrkSuccess,WkReclaim,wkRelease
};